// Shared Recharts theming so every chart matches the design system instead of
// the library's default white-box tooltips and ad-hoc colour arrays.

// Token-aligned categorical palette (single source of truth for pie/series).
export const DATA_COLORS = [
    '#3a3aed', // accent indigo   (--ds-data-1)
    '#0e9f8e', // teal            (--ds-data-2)
    '#e0a100', // amber           (--ds-data-3)
    '#e0567a', // rose            (--ds-data-4)
    '#7c5cff', // violet          (--ds-data-5)
    '#2f8fd6', // blue
    '#f542c8', // magenta
    '#42b8a0', // green-teal
];

// Calm, token-aligned colours for Jira-style workflow statuses
// (replaces the previous neon yellow/green/red that clashed with the UI).
export const STATUS_CHART_COLORS = {
    'ACCEPTED': '#1f9d5b',
    'IN PROGRESS.': '#3a3aed',
    'IN PROGRESS': '#3a3aed',
    'INVALID': '#8a8698',
    'REJECTED': '#d23a2c',
    'TO DO': '#e0a100',
};

// Spread into any <Tooltip {...chartTooltip} /> for a consistent styled card.
export const chartTooltip = {
    contentStyle: {
        background: 'var(--ds-surface)',
        border: '1px solid var(--ds-border-strong)',
        borderRadius: '10px',
        boxShadow: '0 6px 24px rgba(26, 22, 60, 0.14)',
        fontSize: '12px',
        fontFamily: 'var(--ds-font-body)',
        color: 'var(--ds-ink)',
        padding: '8px 10px',
    },
    labelStyle: { color: 'var(--ds-ink-muted)', fontWeight: 600, marginBottom: '2px' },
    itemStyle: { color: 'var(--ds-ink-soft)', padding: '1px 0' },
};

// Hover cursor line for cartesian (line/bar) charts.
export const chartCursor = { stroke: 'var(--ds-border-strong)', strokeWidth: 1 };

// Axis tick + grid styling.
export const axisTick = { fontSize: 12, fill: 'var(--ds-ink-muted)' };
export const gridStroke = 'var(--ds-border)';
